import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { useStore } from '@/providers/app-store-provider';
import { EPlatform } from '@/utils/enums/platform-enum';

import { randomString, visitor } from '@/utils/tools';
import { useContext, useEffect } from 'react';

export const useStorageDataInit = () => {
  const setCanBuyCartsList = useStore((state) => state.setCanBuyCartsList);
  const setCanBuyList = useStore((state) => state.setCanBuyList);
  const setVisitorId = useStore((state) => state.setVisitorId);
  const setWaiMode = useStore((state) => state.setWaiMode);

  const { deviceType } = useContext(ResponsiveContext);
  const inAppH5 = [EPlatform.ANDROID, EPlatform.IOS].includes(deviceType);

  useEffect(() => {
    if (window?.localStorage?.getItem('zl-canBuyList')) {
      setCanBuyList(JSON.parse(window?.localStorage?.getItem('zl-canBuyList') || '[]') as []);
    }
    if (window?.localStorage?.getItem('zl-canBuyCartsList')) {
      setCanBuyCartsList(
        JSON.parse(window?.localStorage?.getItem('zl-canBuyCartsList') || '[]') as [],
      );
    }
    const visitorId = window?.localStorage?.getItem('zl-visitor_id') || visitor();
    setVisitorId(visitorId);

    const blindMode = localStorage.getItem('zl-blind-mode');

    if (blindMode) {
      setWaiMode(blindMode === 'true');
    }

    if (inAppH5) {
      const queryParams = new URLSearchParams(window.location.search);
      sessionStorage.setItem('zl-distinct_id', queryParams.get('distinct_id') || '');
      sessionStorage.setItem('zl-anonymous_id', queryParams.get('anonymous_id') || '');
      const appQuery = {};
      ['app_currency_code', 'version', 'store_id', 'source'].forEach((key) => {
        if (queryParams.get(key)) {
          appQuery[key] = queryParams.get(key);
        }
      });

      sessionStorage.setItem('zl-appQuery', JSON.stringify(appQuery));
    }

    const isFirstVisit = sessionStorage.getItem('zl-is-first-visit');
    if (!isFirstVisit) {
      sessionStorage.setItem('zl-is-first-visit', 'true');
      const aleid = randomString(40);
      localStorage.setItem('zl_axon_aleid', aleid);
    }
  }, []);
};
